import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { ArrowUpRight } from "lucide-react";
import { BLUEFIG_VENDOR_URL } from "@/config";

/**
 * Primary CTA. Opens BlueFig in the top-level browser window so its login
 * cookies remain first-party and customer sessions persist correctly.
 */
export function PortalButton({
  children = "Login / Sign Up",
  variant = "solid",
  className = "",
  showArrow = true,
  testId = "portal-button",
  ...rest
}) {
  const base =
    "group inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold tracking-tight transition-[background-color,color,box-shadow,transform] duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-2";
  const variants = {
    solid: "bg-forest text-butter hover:bg-forest-deep",
    butter: "bg-butter-deep text-forest hover:brightness-105 shadow-hard hover:shadow-hard-lg",
    outline: "border border-forest text-forest hover:bg-forest hover:text-butter bg-transparent",
    "ghost-light": "bg-white/10 text-white border border-white/30 hover:bg-white hover:text-forest backdrop-blur",
  };

  return (
    <motion.button
      type="button"
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.97 }}
      onClick={() => window.location.assign(BLUEFIG_VENDOR_URL)}
      data-testid={testId}
      className={cn(base, variants[variant], className)}
      {...rest}
    >
      {children}
      {showArrow && (
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      )}
    </motion.button>
  );
}
